import { render, staticRenderFns } from "./fund-info.vue?vue&type=template&id=17e6fb84&scoped=true&"
import script from "./fund-info.vue?vue&type=script&lang=js&"
export * from "./fund-info.vue?vue&type=script&lang=js&"
import style0 from "./fund-info.vue?vue&type=style&index=0&id=17e6fb84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e6fb84",
  null
  
)

export default component.exports